export const VER_CardWibContent = 1

export interface ICardWibContent {
    version: number
    description: string,
    autoMembers: string[],
    autoAssignees: string[]
}